import React from 'react'
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material'
import { Link } from 'react-router-dom'

const Header = (): React.JSX.Element => {
  return (
    <AppBar
      position="static"
      color="transparent"
      elevation={0}
      sx={{
        mb: 2,
        border: '1px solid rgba(148, 163, 184, 0.32)',
        borderRadius: 2,
        background: 'linear-gradient(90deg, rgba(15, 23, 36, 0.94), rgba(22, 34, 53, 0.94))'
      }}
    >
      <Toolbar
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'stretch', md: 'center' },
          justifyContent: 'space-between',
          gap: 2,
          py: { xs: 2, md: 1 }
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: { xs: 'center', md: 'flex-start' }, gap: 1.5 }}>
          <img src="/images/nextquest-logo.png" alt="NextQuest" style={{ height: 44 }} />
          <Typography variant="h6" component="div" sx={{ fontWeight: 700, color: '#f8fbff' }}>
            NextQuest
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(4, auto)', md: 'repeat(7, auto)' },
            gap: 1,
            width: { xs: '100%', md: 'auto' }
          }}
        >
          <Button component={Link} to="/" variant="contained" size="small" sx={{ fontWeight: 600 }}>
            Home
          </Button>
          <Button component={Link} to="/Games" variant="contained" size="small" sx={{ fontWeight: 600 }}>
            Search
          </Button>
          <Button component={Link} to="/Library" variant="contained" size="small" sx={{ fontWeight: 600 }}>
            Browse Library
          </Button>
          <Button component={Link} to="/UserProfile" variant="contained" size="small" sx={{ fontWeight: 600 }}>
            Profile
          </Button>
          <Button component={Link} to="/Register" variant="contained" size="small" sx={{ fontWeight: 600 }}>
            Register
          </Button>
          <Button component={Link} to="/Login" variant="contained" size="small" sx={{ fontWeight: 600 }}>
            Login
          </Button>
          <Button component={Link} to="/Support" variant="contained" size="small" sx={{ fontWeight: 600 }}>
            Support
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default Header